import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../../lib/api";
import { useI18n } from "../../context/I18nContext";

export const Quotes = () => {
  const { t, lang } = useI18n();
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/quotes").then((r) => setQuotes(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const fmt = (n) =>
    new Intl.NumberFormat(lang === "fr" ? "fr-FR" : "en-GB", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(n);

  const labelType = (id) =>
    id === "vitrine" ? t("sim.type_vitrine") : id === "ecommerce" ? t("sim.type_ecom") : t("sim.type_app");

  return (
    <div data-testid="dashboard-quotes">
      <div className="flex items-center justify-between mb-6">
        <p className="text-sm text-zinc-400">{t("quotes.intro")}</p>
        <Link
          to="/simulateur"
          data-testid="quotes-new-link"
          className="inline-flex items-center gap-2 bg-white text-zinc-950 hover:bg-zinc-200 px-4 py-2.5 text-sm"
        >
          {t("quotes.new")} <ArrowUpRight size={14} />
        </Link>
      </div>

      {loading ? (
        <p className="text-sm text-zinc-500">{t("common.loading")}</p>
      ) : quotes.length === 0 ? (
        <div className="border border-white/10 border-dashed p-12 text-center">
          <p className="text-zinc-400 text-sm">{t("quotes.empty_t")}</p>
          <p className="text-zinc-600 text-xs mt-1">{t("quotes.empty_d")}</p>
        </div>
      ) : (
        <div className="border border-white/10 divide-y divide-white/10">
          {quotes.map((q) => (
            <div key={q.quote_id} className="grid grid-cols-1 sm:grid-cols-12 gap-4 p-6 bg-zinc-950">
              <div className="sm:col-span-5">
                <p className="font-display text-xl tracking-tight">{labelType(q.params?.site_type)}</p>
                <p className="text-xs text-zinc-500 mt-1 font-mono">#{q.quote_id?.slice(-8)}</p>
              </div>
              <div className="sm:col-span-4 text-sm text-zinc-400">
                {q.params?.pages} {t("sim.pages_unit")} · {q.params?.features?.length || 0} options · {q.params?.hosting}
              </div>
              <div className="sm:col-span-3 sm:text-right">
                <p className="font-mono text-lg">{fmt(q.total_price)}</p>
                <p className="font-mono text-xs text-zinc-500 mt-1">{new Date(q.created_at).toLocaleDateString()}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
